import request from '@/services/axios'

//PPT从回收站恢复
export const pptRecover = (data:any)=>{
    return request.post('/api/ppt/recover', data)
}

//获取工作台 PPT分页
export const getPPTPage = (data:any)=>{
    return request.post('/api/ppt/page', data)
}

//获取工作台 PPT详情
export const getPPTDetaile = (data:any)=>{
    return request.post('/api/ppt/get', data)
}

//ppt修改的增量保存
export const PPTDelta = (data:any)=>{
    return request.post('/api/ppt/delta', data)
}

//删除或加入回收站
export const deletePPT = (data:any)=>{
    return request.post('/api/ppt/delete', data)
}

//PPT重命名
export const pptRename = (data:any)=>{
    return request.post('/api/ppt/rename', data)
}

//PPT创建副本
export const pptCopy = (data:any)=>{
    return request.post('/api/ppt/copy', data)
}


//用户PPT事件
export const pptEvent = (data:any)=>{
    return request.post('/api/ppt/event', data)
}